import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReadOnlyTicketCardTitle = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "conversations-inbox-ui.crm-integration.ThreadTicketCard.title"
});
ReadOnlyTicketCardTitle.displayName = 'ReadOnlyTicketCardTitle';
export default ReadOnlyTicketCardTitle;